function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { setMonth, isSameMonth, isAfter, isBefore, startOfMonth } from 'date-fns';
import { isFunction, isArray } from '@cloud-sn/v-utils';
import { MONTH_STYLE } from '../constant';
import { formatDate } from '../utils';
import MonthYearDecadeMixin from '../mixins/monthYearDecade';
export default {
  name: 'MonthTable',
  mixins: [MonthYearDecadeMixin],
  props: {
    prefixCls: {
      type: String,
      default: undefined
    },
    locale: {
      type: Object,
      default: undefined
    },
    value: {
      type: Date,
      default: undefined
    },
    disabledMonth: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    monthRender: {
      type: Function,
      default: null
    },
    contentRender: {
      type: Function,
      default: null
    }
  },
  computed: {
    months: function () {
      var value = this.value,
          disabledMonth = this.disabledMonth,
          locale = this.locale;
      var months = [];
      var idx = 0;

      for (var i = 0; i < MONTH_STYLE.row; i += 1) {
        months[i] = [];

        for (var j = 0; j < MONTH_STYLE.col; j += 1) {
          var curMonth = setMonth(value, idx);
          var name = formatDate(curMonth, 'MMM', {
            locale: locale.DateFnsLocale
          });
          var disabled = disabledMonth(curMonth);
          months[i].push({
            id: idx,
            title: name,
            name: name,
            value: curMonth,
            disabled: disabled
          });
          idx += 1;
        }
      }

      return months;
    }
  },
  methods: {
    onMouseEnter: function onMouseEnter(month) {
      if (month.disabled) {
        return;
      }

      this.$emit('month-hover', month.value);
      this.onMonthYearDecadeRootHover('month', month.value);
    },
    onSelect: function onSelect(month) {
      if (month.disabled) {
        return;
      }

      this.$emit('on-select', month.value);
      this.$emit('select', month.value);
    },
    getRangeClasses: function getRangeClasses(monthVal) {
      var prefixCls = this.prefixCls,
          isChildren = this.isChildren;

      if (isChildren) {
        var _ref;

        var isInRange = false;
        var isSelectedStartMonth = false;
        var isSelectedEndMonth = false;
        var isSelectedMonth = false;
        var hoverValue = this.monthYearHoverValue,
            selectedValue = this.monthYearSelectedValue;

        if (selectedValue && isArray(selectedValue)) {
          var ranges = hoverValue.length > 0 ? hoverValue : selectedValue;

          var _ranges = _slicedToArray(ranges, 2),
              start = _ranges[0],
              end = _ranges[1];

          if (start) {
            if (isSameMonth(monthVal, start)) {
              isSelectedMonth = true;
              isSelectedStartMonth = true;
            }

            if (end) {
              if (isSameMonth(monthVal, end)) {
                isSelectedMonth = true;
                isSelectedEndMonth = true;
              } else if (isAfter(startOfMonth(monthVal), startOfMonth(start)) && isBefore(startOfMonth(monthVal), startOfMonth(end))) {
                isInRange = true;
              }
            }
          }
        }

        return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-selected-start-month"), isSelectedStartMonth), _defineProperty(_ref, "".concat(prefixCls, "-selected-end-month"), isSelectedEndMonth), _defineProperty(_ref, "".concat(prefixCls, "-in-range-cell"), isInRange), _defineProperty(_ref, "".concat(prefixCls, "-selected-month"), isSelectedMonth), _ref;
      }

      return {};
    },
    cellClasses: function cellClasses(month) {
      var _objectSpread2;

      var prefixCls = this.prefixCls,
          value = this.value,
          isChildren = this.isChildren;
      var monthVal = month.value;
      var rangeClasses = this.getRangeClasses(monthVal);
      return _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, "".concat(prefixCls, "-cell"), true), _defineProperty(_objectSpread2, "".concat(prefixCls, "-cell-disabled"), month.disabled), _defineProperty(_objectSpread2, "".concat(prefixCls, "-selected-cell"), !isChildren && isSameMonth(value, monthVal)), _defineProperty(_objectSpread2, "".concat(prefixCls, "-current-cell"), !isChildren && isSameMonth(monthVal, new Date())), _objectSpread2), rangeClasses);
    },
    renderCell: function renderCell(col) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          value = this.value,
          monthRender = this.monthRender,
          contentRender = this.contentRender,
          cellClasses = this.cellClasses,
          onMouseEnter = this.onMouseEnter,
          onSelect = this.onSelect;
      var content = null;

      if (isFunction(monthRender)) {
        content = monthRender({
          current: col.value,
          value: value
        });
      } else {
        var cellContent = isFunction(contentRender) ? contentRender({
          current: col.value,
          value: value
        }) : col.name;
        content = h("a", {
          "class": "".concat(prefixCls, "-month")
        }, [cellContent]);
      }

      return h("td", {
        "attrs": {
          "role": "gridcell",
          "title": col.title
        },
        "class": cellClasses(col),
        "on": {
          "mouseenter": function mouseenter() {
            return onMouseEnter(col);
          },
          "click": function click() {
            return onSelect(col);
          }
        }
      }, [content]);
    },
    renderCells: function renderCells() {
      var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var renderCell = this.renderCell;
      return month.map(function (col) {
        return renderCell(col);
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        months = this.months,
        renderCells = this.renderCells;
    return h("table", {
      "attrs": {
        "role": "monthgrid",
        "cellSpacing": "0"
      },
      "class": "".concat(prefixCls, "-table")
    }, [h("tbody", {
      "class": "".concat(prefixCls, "-tbody")
    }, [months.map(function (month, i) {
      return h("tr", {
        "attrs": {
          "role": "row"
        },
        "key": i
      }, [renderCells(month)]);
    })])]);
  }
};